import { ENV_CONFIG } from "common/config/env.config";

const removeTrailingSlash = (value: string) => value.replace(/\/+$/, "");

const removeLeadingSlash = (value: string) => value.replace(/^\/+/, "");

const buildApiUrlWithBase = (path: string, base?: string): string => {
  if (!base) {
    return path;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const cleanBase = removeTrailingSlash(base);
  const cleanPath = removeLeadingSlash(path);
  const prefixedPath = cleanPath.startsWith("api/")
    ? cleanPath
    : `api/${cleanPath}`;

  return `${cleanBase}/${prefixedPath}`;
};

/**
 * Builds an absolute URL targeting the GDX API host.
 * Falls back to the incoming path when the GDX base is not configured.
 */
export const buildGdxApiUrl = (path: string): string => {
  return buildApiUrlWithBase(path, ENV_CONFIG.GDX_API_URL);
};

/**
 * Builds an absolute URL targeting the Engineering API host.
 * Falls back to the incoming path when the Engineering base is not configured.
 */
export const buildEngApiUrl = (path: string): string => {
  return buildApiUrlWithBase(path, ENV_CONFIG.ENG_API_URL);
};

/**
 * Builds an absolute URL targeting the Search API host.
 * Falls back to the incoming path when the Search base is not configured.
 */
export const buildSearchApiUrl = (path: string): string => {
  return buildApiUrlWithBase(path, ENV_CONFIG.SEARCH_API_URL);
};
